import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"items":_vm.agencies,"item-text":"display","item-value":"agency_code","hide-no-data":"","label":_vm.$t('labels.agency'),"disabled":_vm.isDisabled,"required":"","error-messages":_vm.errors,"clearable":""},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }